<template>
  <v-card v-if="vehicle != null">
    <ODialogBar no-close title="Contadores">
      <v-btn icon class="ml-1" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn icon @click="startEdit">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>
    <OLoadingLine absolute :value="isLoading" />
    <v-card-text class="pa-4 d-flex flex-row flex-wrap">
      <EditCountersDialog ref="editDialog" />
      <OCapCont class="w-1/2 pa-2" label="Horímetro">
        {{ vehicleData.horometer | sHoro }}
      </OCapCont>

      <OCapCont class="w-1/2 pa-2" label="Odômetro">
        {{ vehicleData.odometer | mDistance }}
      </OCapCont>

      <OAlert error v-if="errMessage != null">
        Houve um erro ao recuperar os contadores: {{ errMessage }}
      </OAlert>
    </v-card-text>
  </v-card>
</template>

<script>
import EditCountersDialog from './EditCountersDialog.vue'
import { OrgApi } from '@/models'
import formatters from 'oderon-commons/src/formatters.js'

export default {
  expose: ['reload'],
  components: { EditCountersDialog },
  props: {
    vehicle: { required: true }
  },
  data() {
    return { isLoading: false, vehicleData: {}, errMessage: null }
  },
  mounted() {
    this.reload()
  },
  watch: {
    vehicle() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loadingQuiet(() => this.fetchData())
    },
    async fetchData() {
      // await this.$delay(1000)
      let fetcher = new OrgApi(this.vehicle.orgId)
      this.vehicleData = await fetcher.get(`vehicles/${this.vehicle.idInOrg}`)
    },

    async startEdit() {
      let res = await this.$refs.editDialog.open(this.vehicle)
      if (res === true) {
        this.$emit('reload')
      }
    }
  },
  filters: {
    sHoro(x) {
      if (x == null) return '─'
      return formatters.brDec(x / 3600) + ' h'
    },
    mDistance(x) {
      if (x == null) return '─'
      return formatters.brDec(x / 1000) + ' km'
    }
  }
}
</script>

<style lang="sass"></style>
